/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkBestPractice {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkBestPractice.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkBestPractice>): WellArchitectedFrameworkBestPractice {
        let obj = Object.assign(new WellArchitectedFrameworkBestPractice(), model);
        WellArchitectedFrameworkBestPractice.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkBestPractice>): WellArchitectedFrameworkBestPractice {
        if (!model) return null;
        return WellArchitectedFrameworkBestPractice.newInstance(<WellArchitectedFrameworkBestPractice> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkBestPractice) {
        if (!obj) return;

        models.WellArchitectedFrameworkBestPractice.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkBestPractice): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkBestPractice.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the framework associated with the best practice
     */
    framework_id: string;

    /**
     * ID of the pillar associated with the best practice
     */
    pillar_id: string;

    /**
     * ID for the question associated with the best practice
     */
    question_id: string;

    /**
     * ID for the best practice
     */
    best_practice_id: string;

    /**
     * ID of best practice
     */
    hyperscaler_best_practice_id: string;

    /**
     * Best practice at question level
     */
    best_practice: string;

    /**
     * Statement of the best practice
     */
    description: string;

    /**
     * Statement of the best practice
     */
    recommendation: string;

    /**
     * Nature of the best practice
     */
    nature: models.WellArchitectedFrameworkBestPracticeNature;

    /**
     * Risk of the best practice
     */
    risk: models.WellArchitectedFrameworkRisk;

    /**
     * URIs of the Policies associated with this best practice
     */
    policy_uris: Array<string>;

    /**
     * Flag to indicate whether the best practice is automatable
     */
    is_automatable: boolean;

    /**
     * Flag to indicate whether the best practice is None of the above
     */
    is_none_of_the_above: boolean;

}
